module.exports = __webpack_public_path__ + "static/media/catalog-prestashop.50316a52.png";